exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!./normalize.css"), "");

// Module
exports.push([module.id, "/*! normalize rule for Sinitic */\n", ""]);

